import { render, staticRenderFns } from "./TrustSection.vue?vue&type=template&id=39cda55e"
import script from "./TrustSection.vue?vue&type=script&lang=js"
export * from "./TrustSection.vue?vue&type=script&lang=js"
import style0 from "./TrustSection.vue?vue&type=style&index=0&id=39cda55e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports